import React from 'react';
import { Button, Item } from 'semantic-ui-react';
import { ITrainingBloc } from '../classes';
import './Bloc.css';
import { formatTime } from '../../../utils/Formatter';
import Hands from "../../../components/Hands/Hands";
import { withTranslation, WithTranslation } from 'react-i18next';
import { HangboardDisplay } from '../../../assets/hangboards/hangboardDisplay';
import { useSelector } from 'react-redux';
import { State } from '../../../reducers';


interface ITrainingBlocProps extends WithTranslation{
    bloc: ITrainingBloc
    hangboard: any
    intensityType: string
}

const TrainingBloc = (props: ITrainingBlocProps) => {
    const fingers = [ 'Thumb', 'Index', 'Middle', 'Ring', 'Pinky'];
    
    const displayFingers = (hand: string) => {
        const handIndex = hand == 'Left' ? 0 : 1;
        const fingersValues = handIndex == 0 ? [...fingers].reverse() : [...fingers];
        return fingersValues.map((finger) => {
            let fingerIndex = fingersValues.findIndex(x => x == finger);
            const isActive = props.bloc.fingers[handIndex][fingerIndex] == 1 ? true : false;
             //if (finger != 'Thumb')
                return <Button toggle active={isActive} onClick={() => props.bloc.setFingers(handIndex, fingerIndex)}> {finger} </Button>
            //return null;
        }
        );
    }
    
    const displayGuidelines = () => {
        const hangboard = props.hangboard !== 'none' ? <HangboardDisplay unclickable name={props.hangboard} usedHolds={props.bloc.usedHolds} /> : null;
        const displayStyle = props.hangboard !== 'none' ? 'inline-block' : 'contents';
        return(  
        <div className='trainingBlocGuidelinesContainer' style={{display: displayStyle}}>
            {hangboard}
            <Hands fingers={props.bloc.fingers} fingerClicked={(hand: number, finger: number) => props.bloc.setFingers(hand, finger)} />
        </div>
        )
    }
       
    const weightUnit = useSelector((state:State) => state.authentication.user.displaySettings.weightUnit);
    const weightFactor = weightUnit == 'kg' ? 1 : 2.2;

    const handleIntensity = () => {
        switch (props.intensityType) {
            case 'absolute':
                return `${Math.round(props.bloc.intensity * weightFactor)} ${weightUnit}`;
            case 'strengthRelative':
                return `${Math.round(props.bloc.intensity)}${props.t('bloc.strengthRelative')}`;
            case 'weightRelative':
                return `${Math.round(props.bloc.intensity)}${props.t('bloc.weightRelative')}`;
            default: return null;
        }
    }

    return (
        <div className='bloc'>
            <div className='bloc-content'>
                <Item.Group>
                    <Item>
                        
                        <div className='centered-content'>
                            <Item.Content>
                                <Item.Header>
                                    {props.t(props.bloc.guideline)}
                                </Item.Header>
                                <Item.Meta>
                                    {formatTime(props.bloc.time)}
                                </Item.Meta>
                                <Item.Meta>
                                    {handleIntensity()}
                            </Item.Meta>
                            </Item.Content>
                        </div>
                        {displayGuidelines()}
                    </Item>
                </Item.Group>

            </div>
        </div>

    )
}


export default withTranslation('workout') (TrainingBloc);